import PageData from "../../../common/ts/PageData";

export default class HipflatScheduleModal {
    private scheduleForm: HTMLElement | null | undefined;
    constructor(pageData: PageData) {
        this.scheduleForm = document.querySelector(".js-schedule-contact-form") as HTMLElement;
        document.querySelector(".js-schedule-confirm")?.addEventListener('click', () => {
            // alert("hola me llamo bernabé");
            const dateInputValue = this.scheduleForm!.querySelector('.js-date-value:checked') as HTMLInputElement | null;
            const timeInputValue = this.scheduleForm!.querySelector('.js-time-value:checked') as HTMLInputElement | null;
            this.scheduleForm!.querySelector('.js-resume__date')!.textContent = dateInputValue!.value;
            this.scheduleForm!.querySelector('.js-resume__time')!.textContent = timeInputValue!.value;
            this.scheduleForm!.querySelector('.js-schedule')!.classList.add('hidden')
            this.scheduleForm!.querySelector('.js-form')!.classList.remove('hidden')
            this.scheduleForm!.querySelector('.js-form')!.classList.add('flex')
        });

    }


    static init = (pageData: PageData) => {
        new HipflatScheduleModal(pageData);
    }
}